import React from "react"
import { Typography } from "@mui/material"
export const DataStatus = () => <div className="pagination-div"><Typography variant="h6">No Data to show</Typography></div>